import * as epcLookupActions from '../actions/epcLookup';

const defaultState = {
    form: {
        initialValues: {},
        initialStatus: {
            errors: {},
        },
    },
    showLookupError: false,
    showLookupSpinner: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case epcLookupActions.LOOKUP_STATE_REFRESHED:
            return {
                ...state,
                showLookupError: action.showLookupError,
                showLookupSpinner: action.showLookupSpinner,
            };
        case epcLookupActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
